var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemperature = function SvgTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17a2.5 2.5 0 1 1-3.25-2.386V6.75a.75.75 0 0 1 1.5 0v7.865A2.5 2.5 0 0 1 9.5 17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5a5 5 0 0 1 10 0v7.101a7 7 0 1 1-10 0zm5-3a3 3 0 0 0-3 3v7.528a1 1 0 0 1-.333.745 5 5 0 1 0 6.666 0 1 1 0 0 1-.333-.745V5a3 3 0 0 0-3-3",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M15 7a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
  })));
};
export default SvgTemperature;